import { Component, Input } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {IEltern} from "../../../models/IEltern.interface";
import {IKind} from "../../../models/IKind.interface";
import {Geschlecht, Schwimmabzeichen} from "../../../models/enums";
import {KindService} from "../../../service/kind.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-create-kind',
  templateUrl: './create-kind.component.html',
  styleUrls: ['./create-kind.component.scss']
})
export class CreateKindComponent {

  @Input() eltern?: IEltern;
  public transferleistung = false;
  public saving = false;
  private findAndCloseTimeout: any;

  public kind: IKind = {
    id: -1,
    created: 0,
    edited: 0,
    vorname: "",
    nachname: "",
    geschlecht: Geschlecht.DIVERS,
    strasse: "",
    hausnummer: "",
    ort: "",
    plz: 0,
    zusatz: "",
    geburtsdatum: Date.now(),
    soziPass: "",
    soziFile: "",
    soziFile2: "",
    krankheiten: "",
    medikamente: "",
    allergien: "",
    schwimmabzeichen: Schwimmabzeichen.KEINS,
    bemerkung: "",
    laktose: false,
    vegetarier: false,
    veganer: false,
    eltern: null,
    aktivierungsdatum: null,
    rechnungGesendet: null,
    anmeldungen: [],
    bezahlterBetrag: 0,
    rechnungen: []
  };

  constructor(
      public activeModal: NgbActiveModal,
      private kinderService: KindService,
      private toastrService: ToastrService
  ) { }

  async saveKind(): Promise<void> {
    if (!this.eltern) {
      this.toastrService.error("Bitte zuerst einen Elternteil auswaehlen.", "Eltern fehlt");
      return;
    }
    if (this.transferleistung) {
      if (!this.kind.soziPass) {
        this.toastrService.error("Bitte geben Sie eine Bildungspassnummer ein!", "Passnummer fehlt!");
        return;
      }
      if (!this.kind.soziFile) {
        this.toastrService.error("Bitte laden Sie den Bildungspass hoch!", "Pass fehlt!");
        return;
      }
    } else {
      this.kind.soziPass = null;
      this.kind.soziFile = null;
    }
    try {
      this.saving = true;
      this.kind.eltern = this.eltern;
      const result = await this.kinderService.create(this.kind);
      this.toastrService.success(result.msg, "Erfolgreich");
      this.findAndClose(result.id!);
    } catch (exc) {
      this.toastrService.error(exc, "Fehler");
    } finally {
      this.saving = false;
    }
  }

  findAndClose(id: number, retry = 600) {
    this.findAndCloseTimeout = setTimeout(() => {
      const k = this.kinderService.getById(id);
      if (k) {
        this.activeModal.close(k);
      } else if (retry > 0) {
        this.findAndClose(id, retry - 1);
      }
    }, 100);
  }

}
